import styled from "styled-components";
import { Footer, Type } from "discover.medical.react-component-library";

export const StyledFooterContainer = styled.div`
  background: ${({ theme }) => theme.colors.gray100};
  flex-shrink: 0;
  padding-bottom: 2.875rem;

  @media print {
    display: none;
  }
`;

export const StyledFooter = styled(Footer)`
  margin: auto auto 0;
  max-width: 1440px;
`;

export const StyledFooterLogo = styled.img`
  height: ${({ $logo }) => $logo?.height};
`;
